import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { SuccessPopupComponent } from './success-popup.component';

@Injectable()
export class SuccessPopupService {

  constructor(
    private dialog: MatDialog,
    private route: Router) { }

  successBox(payload) {
    const { showCloseBtn} = payload;
    const _dialog = this.dialog.open(SuccessPopupComponent, {
      disableClose: payload.disableClose === true?true:false,
      width: '100%',
      maxWidth: '450px',
      minHeight: '450px',
      data: {
        title: payload.title,
        message: payload.message,
        btn1: payload.btn1,
        showCloseBtn:payload.showCloseBtn?true:false,
        redirectUrl: payload.redirectUrl
        // ...showCloseBtn && showCloseBtn
      }
    })

    _dialog.afterClosed().subscribe(result => {
      if(payload.redirectUrl){
        this.route.navigateByUrl(payload.redirectUrl);
      }
    });
  }
}
